import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import { HeaderProps } from '../../components/Header'
import { selectors } from '../../redux'
import { Icons } from '../../components/Icon'
import { router, routesPath } from '../../router'
import { ActionButtonLook, ActionButtonVariant } from '../../components/ActionButton/styled'

export const useHeader = (): HeaderProps => {
  const isConnected = useSelector(selectors.auth.isConnected)
  const user = useSelector(selectors.auth.user)
  const { t } = useTranslation()

  return {
    logo: {
      src: `${import.meta.env.BASE_URL}images/logo.png`,
      alt: t('header.logo.alt'),
      logoLink: router(routesPath.home),
    },
    text: t('header.title'),
    action: isConnected
      ? {
          text: `${user?.firstName} ${user?.lastName}`,
          href: router(routesPath.account),
          variant: ActionButtonVariant.secondary,
          look: ActionButtonLook.outlined,
          iconPosition: 'left',
          noTextOnMobile: true,
          iconProps: {
            icon: Icons.user,
          },
        }
      : {
          text: t('header.cta.connect'),
          href: router(routesPath.onboarding),
          variant: ActionButtonVariant.secondary,
          look: ActionButtonLook.outlined,
          iconPosition: 'left',
          noTextOnMobile: true,
          iconProps: {
            icon: Icons.user,
          },
        },
  }
}
